<template lang="pug">
div
  div
    button.back(v-if="$route.params.origin == 'balance_sheet'" @click="$router.push({ name: 'dashboard', params: { isPrincipalPath: false } })")
      vm-icon(icon="arrow-back-outline" size="2rem")
    button.back(v-else @click="$router.push({ name: 'projects' })")
      vm-icon(icon="arrow-back-outline" size="2rem")
  div.dashboard
    div.container
      div.tabs-container
        div.tabs-item(@click="handleTabClick(tabNames.SUMMARY)" :class="{ 'tabs-item-active': activeTabName === tabNames.SUMMARY }") {{ $t('strings.summary') }}
        div.tabs-item(@click="handleTabClick(tabNames.FLOWS)" :class="{ 'tabs-item-active': activeTabName === tabNames.FLOWS }") {{ $t('strings.flows') }}
    Component(:is="currentTab")
</template>

<script>
const Flows = () => import('@/components/dashboard/projects/Flows.vue')
const Summary = () => import('@/components/dashboard/projects/Summary.vue')
const tabNames = {
  FLOWS: 'Flows',
  SUMMARY: 'Summary'
}
export default {
  components: {
    Flows,
    Summary
  },
  data: () => ({
    currentTab: Summary,
    activeTabName: 'Summary',
    tabNames,
    tabs: {
      [tabNames.FLOWS]: Flows,
      [tabNames.SUMMARY]: Summary
    },
    origin: null
  }),
  created () {
    this.origin = this.$route.params.origin
  },
  methods: {
    handleTabClick (tabName) {
      this.activeTabName = tabName
      this.currentTab = this.tabs[tabName]
    }
  }
}
</script>
<style scoped lang="scss">
.dashboard {
  background-color: #fafafa;
  padding: 0 5rem 0 5rem;
}
.container {
  margin-bottom: 1rem;
}
.tabs-container {
  display: flex;
}
.tabs-item {
  padding: 0.5rem;
  margin-right: 1rem;
  text-align: left;
  cursor: pointer;
}
.tabs-item-active,
.tabs-item:hover {
  border-bottom: solid 0.3rem rgb(180, 3, 3);
  border-radius: 0.18rem;
}

</style>
